import type React from 'react';

import { Separator, Text } from '@change/ds-core-ui';
import { CheckIcon } from '@change/ds-icons';

import { Html } from 'src/app/shared/components/html';

import { useExtendedComboCopy } from './hooks/useExtendedComboCopy';

export const ExtendedComboCopy: React.FC = () => {
	const {
		data: { subheadingText2, description, subtitle, items },
	} = useExtendedComboCopy();

	return (
		<div className="flex flex-col gap-4">
			<Text as="h2" variant="heading">
				{subheadingText2}
			</Text>
			<Text variant="body" className="text-typography-weak">
				{description}
			</Text>
			<Text as="h3" variant="heading" size="xx-small">
				{subtitle}
			</Text>
			<ul className="m-0 flex list-none flex-col gap-4">
				{items.map((item, index) => (
					<li key={`${item}-${index}`} className="flex items-start gap-3">
						<CheckIcon className="text-icon-information mt-1" size={16} />
						<Html as="div" html={item} className="text-typography-weak" />
					</li>
				))}
			</ul>
			<Separator className="mt-3 mb-0" />
		</div>
	);
};
